export default "__VITE_ASSET__DcKjtdCy__"